import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import styles from './Header.module.css'

export default function Header() {

  const [expandHome, setExpandHome] = useState<boolean>(false)
  const [expandAbout, setExpandAbout] = useState<boolean>(false)
  const [expandStack, setExpandStack] = useState<boolean>(false)
  const [expandProjects, setExpandProjects] = useState<boolean>(false)
  const [expandContact, setExpandContact] = useState<boolean>(false)
  const [isMenuActive, setIsMenuActive] = useState<boolean>(false)

  function underliningHome () {
    setExpandHome(state => !state)
    setIsMenuActive(false)
  }
  

  function underliningAbout () {
    setExpandAbout(state => !state)
    setIsMenuActive(false)
  }

  function underliningStack () {
    setExpandStack(state => !state)
    setIsMenuActive(false)
  }

  function underliningProjects () {
    setExpandProjects(state => !state)
    setIsMenuActive(false)
  }

  function underliningContact () {
    setExpandContact(state => !state)
    setIsMenuActive(false)
  }

  function changeHamburger() {
    
    setIsMenuActive( state => !state)
  }
  console.log(isMenuActive)

    return (
      <div id={styles.header}>
        <h1>Tendai Karuwo</h1>

        <div id={styles.end} className={isMenuActive ? styles.open : styles.menuClose}>
          <nav id={styles.nav}>
            <NavLink
              className={styles.navlink}
              style={
                (({ isActive }) => {
                  return isActive
                    ? {
                        color: "#BB86FC",
                        textDecoration: "none",
                        transition: "all 1s ease",
                      }
                    : {
                        color: "#fff",
                        textDecoration: "none",
                        transition: "all 1s ease",
                      };
                })
              }
              to="/"
            >
              <h3 onMouseEnter={underliningHome} onMouseLeave={underliningHome}>Home</h3>
              <div className={expandHome ? styles.homeHover : styles.home}></div>
            </NavLink>

            <NavLink  style={
                (({ isActive }) => {
                  return isActive
                    ? {
                        color: "#BB86FC",
                        textDecoration: "none",
                        transition: "all 1s ease",
                      }
                    : {
                        color: "#fff",
                        textDecoration: "none",
                        transition: "all 1s ease",
                      };
                })} to="about">
              <h3 onMouseEnter={underliningAbout} onMouseLeave={underliningAbout}>About</h3>
              <div className={expandAbout ? styles.homeHover : styles.home}></div>
            </NavLink>

            <NavLink  style={
                (({ isActive }) => {
                  return isActive
                    ? { color: "#BB86FC", textDecoration: "none", transition: "all 1s ease" }
                    : { color: "#fff", textDecoration: "none", transition: "all 1s ease" };
                })} to="techstack">
              <h3 onMouseEnter={underliningStack} onMouseLeave={underliningStack}>Tech-Stack</h3>
              <div className={expandStack ? styles.homeHover : styles.home}></div>
            </NavLink>

            <NavLink  style={
                (({ isActive }) => {
                  return isActive
                    ? { color: "#BB86FC", textDecoration: "none", transition: "all 1s ease" }
                    : { color: "#fff", textDecoration: "none", transition: "all 1s ease" };
                })} to="Projects">
              <h3 onMouseEnter={underliningProjects} onMouseLeave={underliningProjects}>Projects</h3>
              <div className={expandProjects ? styles.homeHover : styles.home}></div>
            </NavLink>

            <NavLink  style={
                (({ isActive }) => {
                  return isActive
                    ? { color: "#BB86FC", textDecoration: "none", transition: "all 1s ease" }
                    : { color: "#fff", textDecoration: "none", transition: "all 1s ease" };
                })} to="contact">
              <h3 onMouseEnter={underliningContact} onMouseLeave={underliningContact}>Contact</h3>
              <div className={expandContact ? styles.homeHover : styles.home}></div>
            </NavLink>
          </nav>

          

          <a id={styles.cv} href="./CV/TendaiKaruwoCV.pdf" download>
            <h3>CV</h3>
          </a>

        </div>

        <div className={styles.hamburger} onClick={changeHamburger}>
            <div className={isMenuActive ? styles.crossLeft : styles.hamburger }></div>
            <div  className={isMenuActive ? styles.secondHidden : styles.hamburger }></div>
            <div className={isMenuActive ? styles.crossRight : styles.hamburger }></div> 
        </div>
        
      </div>
    );
}

